import { Pipe, PipeTransform } from '@angular/core';
import { LabelsProviderPipe } from '../labels-provider/labels-provider.pipe';

@Pipe({
  name: 'requiredFieldTitle',
})
export class RequiredFieldTitlePipe implements PipeTransform {
  constructor(private readonly _labelsProviderPipe: LabelsProviderPipe) {}

  public transform(value: string): string {
    return this._labelsProviderPipe.transform(value) + ' <span class="required-asterisk">*</span>';
  }
}
